module.exports = __webpack_public_path__ + "img/spitter-die-mask-4.e22a1e75.png";